import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { subscribeAllEntitiesResolver } from '@adornis/baseql/server/resolver/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Client } from '@nsc/clients/entities/Client.js';
import {
  gateNexusSubscription,
  gatePlatformUserManageSubscription,
} from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';

/** All clients for ERM scope assignment ({@link NexusPermission.UserManage}). */
export const subscribeAllClientsForNexus = registerSubscription({
  operationName: 'subscribeAllClientsForNexus',
  type: () => [Client],
  params: [],
  resolve: () => (gqlFields: BaseQLSelectionSet<Client>) =>
    gatePlatformUserManageSubscription(() => subscribeAllEntitiesResolver(Client._class)(gqlFields)),
});

/** All clients for client admin UI ({@link NexusPermission.ClientManage}). */
export const subscribeClientsForNexusManage = registerSubscription({
  operationName: 'subscribeClientsForNexusManage',
  type: () => [Client],
  params: [],
  resolve: () => (gqlFields: BaseQLSelectionSet<Client>) =>
    gateNexusSubscription(NexusPermission.ClientManage, () => subscribeAllEntitiesResolver(Client._class)(gqlFields)),
});
